<template>
  <q-page padding class="docs-tab-pane row justify-center">

    <div style="width: 100%; max-width: 90vw;">
      <q-tabs  inverted align="justify" >
        <q-tab default name="profile" slot="title" icon="person" :label="$t('profiletitle')" />
        <!-- <q-tab name="language" slot="title" icon="language" :label="$t('profile.lang')" /> -->

        <q-tab-pane name="profile" style="border:0px">
            <div class = "q-ml-xl q-mr-xl" >
            <q-field :label="$t('lastname') + ' ' + $t('firstname') + ' ' + $t('surname')">
                <q-input type="text" v-model="form.fio" readonly style = "float:left; width:50%"/>
                <q-btn icon = "edit" color = "primary" round size = "sm" outline>
                    <q-popup-edit v-model="form.fio" :title="$t('changetitle')" buttons persistent :validate="val => form.fio!=''" @save="saveFIO()">
                        <q-field count :error-label="$t('errors.emptyvalue')" :error="form.fio==''">
                            <q-input v-model="form.fio" />
                        </q-field>
                    </q-popup-edit>
                </q-btn>
            </q-field>

            <q-field :label="$t('email')">
                <q-input type="text" v-model = "form.email" readonly style = "float:left; width:50%"/>
                <q-btn icon = "edit" color = "primary" round size = "sm" outline>
                    <q-popup-edit v-model="form.email" :title="$t('changetitle')" buttons persistent :validate="val => form.email!=''" @save="saveEmail()">
                        <q-field count>
                            <q-input  v-model="form.email" :error-label="$t('errors.emptyvalue')" :error="form.email==''"/>
                        </q-field>
                    </q-popup-edit>
                </q-btn>
            </q-field>

            <q-field :label="$t('phone')">
                <q-input type="text" v-model = "form.phone" readonly style = "float:left; width:50%"/>
            </q-field>

            <div class = "row justify-center q-mt-md">       
                <q-btn :label="$t('changepassbtn')" color = "primary">
                    <q-popup-edit v-model="form.pass" :title="$t('changepass')" buttons persistent  @save="changePass()">
                        <q-field count :label="$t('oldpass')">
                            <q-input  v-model="form.pass" :error-label="$t('errors.emptyvalue')" type="password" />
                        </q-field>
                        <q-field count :label="$t('newpass')">
                            <q-input  v-model="form.passnew" :error-label="$t('errors.emptyvalue')" type="password" />
                        </q-field>

                    </q-popup-edit>
                </q-btn>
            </div>

         </div>

        </q-tab-pane>

        <!-- <q-tab-pane name="language" style="border:0px">
            <div style="width: 20vw; max-width: 90vw; margin-left: 10%; width: 80%; padding-top: 3%;">
                <p class = "caption">{{$t('profile.langtitle')}}</p>
                    <q-select color="primary" inverted
                        :options="[
                        { label: 'Русcкий', value: 'ru' },
                        { label: 'English', value: 'en-us' },
                        { label: 'Franch',  value: 'fr' }
                        ]"
                        v-model="lang"
                    />
            </div>
        </q-tab-pane> -->

      </q-tabs>
    </div>
    <!-- {{ $store.state.states }} -->
  </q-page>
</template>

<script>

import axios from 'axios'

export default {
data () {
    return {
        lang: this.$store.state.lang,
        form: {
            fio: '',
            email: '',
            phone: '',
            pass: '',
            passnew: ''
            }
        }
    },    

    watch: {
        lang (lang) {
            import(`quasar-framework/i18n/${lang}`).then(lang => {
                this.$q.i18n.set(lang.default)
                //console.log(lang.default.lang)
                switch (lang.default.lang)
                {
                    case 'ru': this.$i18n.locale = 'ru';  break;
                    case 'en-us': this.$i18n.locale = 'en';  break;
                    case 'fr': this.$i18n.locale = 'fr';  break;
                }
                this.$store.commit('set_lang', lang.default.lang)
            })
        }
    },

    mounted ()
    {
        this.loadSettings()
    },
    methods:
    {

    changePass: function()
    {
        let request = {
            old_pass: this.form.pass,
            new_pass: this.form.passnew

        }
        const requestStr = JSON.stringify(request)
        axios.put (this.$root.api_url + 'user/me/', requestStr, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token                
            }
            })  
            .then(() => {
              this.$q.notify({
                  message: this.$t('changepasssucc'),
                  type: 'positive',
                  icon: 'thumb_up'
              })
              this.form.pass = ''
              this.form.passnew = ''
              this.loadSettings()
            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('errors.changepass'),
                    type: 'negative',
                    icon: 'report_problem'
                })
                this.form.pass = ''
                this.form.passnew = ''
            })
            
    },
    saveEmail: function()
    {
        let request = {
            email: this.form.email
        }
        const requestStr = JSON.stringify(request)
        axios.put (this.$root.api_url + 'user/me/', requestStr, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token                
            }
            })  
            .then(() => {
              this.$q.notify({
                  message: this.$t('savesettingssucc'),
                  type: 'positive',
                  icon: 'thumb_up'
              })
              this.loadSettings()
            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('errors.error'),
                    type: 'negative',
                    icon: 'report_problem'
                })
            })
    },


    saveFIO: function()
    {
        let request = {
            name: this.form.fio
        }
        const requestStr = JSON.stringify(request)
        axios.put (this.$root.api_url + 'user/me/', requestStr, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token                
            }
            })  
            .then(() => {
              this.$q.notify({
                  message: this.$t('savesettingssucc'),
                  type: 'positive',
                  icon: 'thumb_up'
              })
              this.$store.commit('set_name', this.form.fio)
              this.loadSettings()
            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('errors.error'),
                    type: 'negative',
                    icon: 'report_problem'
                })
            })
    },

    loadSettings: function()
        {

        axios.get (this.$root.api_url + 'user/me/', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'JWT ' + this.$store.state.token                
            }
            })  
            .then((data) => {
                this.form.fio = data.data.name
                this.form.email = data.data.email
                this.form.phone = data.data.phone
            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('errors.regerr'),
                    type: 'negative',
                    icon: 'report_problem'
                })
            })
        }

    },
    components: {  }

}

</script>
